module.exports = __webpack_public_path__ + "static/readmore-e5e028d7ef1cb02bd6f5e18697c73d20.png";